import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import Masonry from 'react-masonry-css';

import './style.scss';

import ArrowsIcon from './assets/arrows.inline.svg';
import CheckboxesIcon from './assets/checkboxes.inline.svg';
import LightIcon from './assets/light.inline.svg';
import ShieldIcon from './assets/shield.inline.svg';
import TemplateIcon from './assets/template.inline.svg';
import WindowsIcon from './assets/windows.inline.svg';

const BenefitsSection = () => {
  return (
    <section className="l-benefits">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
        <div className="bg2" />
      </Parallax>

      <div className="container">
        <div className="content">
          <h2 className="section-title">A New Application Framework with Many Benefits</h2>
          <p>
            The new Framework is designed to deliver key strategic benefits on behalf of state and territory
            governments, including:
          </p>
          <ul>
            <li>a clear focus on consumer protection and the public interest</li>
            <li>modern and integrated regulatory processes</li>
            <li>evidence based decision-making capable of demonstrating achievement of the statutory objectives</li>
            <li>regulatory excellence through collaborative engagement.</li>
          </ul>
        </div>

        <Masonry className="cards" columnClassName="cards-column">
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <WindowsIcon />
            </div>
            <div className="card-content">
              <strong>Six modules</strong>
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <LightIcon />
            </div>
            <div className="card-content">
              <strong>New workshops,</strong> including a ‘readiness to regulate’ session
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <TemplateIcon />
            </div>
            <div className="card-content">
              <strong>New templates</strong> and additional guidance
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <CheckboxesIcon />
            </div>
            <div className="card-content">
              <strong>Modularised format,</strong> for new schemes, remakes and amendments
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <ArrowsIcon />
            </div>
            <div className="card-content">
              <strong>Different application pathways</strong> where separate modules can be completed free-standing
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-icon">
              <ShieldIcon />
            </div>
            <div className="card-content">
              Greater emphasis on <strong>Consumer protection</strong>
            </div>
          </div>
        </Masonry>
      </div>
    </section>
  );
};

export default BenefitsSection;
